import { render, staticRenderFns } from "./Floater.vue?vue&type=template&id=78c58ffe&"
import script from "./Floater.vue?vue&type=script&lang=js&"
export * from "./Floater.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports